module.exports = __webpack_public_path__ + "img/53.c6817447.jpeg";